import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_BEGIN,
  LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_SUCCESS,
  LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_FAILURE,
  LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';
import initialState from './initialState';

export function buscarAgendamentoRpa(agendamentoRpaId) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_BEGIN,
    agendamentoRpaId
  };
}

export function dismissBuscarAgendamentoRpaError() {
  return {
    type: LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_BEGIN actions
export function* doBuscarAgendamentoRpa(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    const AgendamentoRPAApi = new Services['AgendamentoRPAApi']();
    res = yield AgendamentoRPAApi.loginAgendamentoRPA(action.agendamentoRpaId);
  } catch (err) {
    yield put({
      type: LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchBuscarAgendamentoRpa() {
  yield takeLatest(LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_BEGIN, doBuscarAgendamentoRpa);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_BEGIN:
      return {
        ...state,
        registroAgendamentoRPA: initialState.registroAgendamentoRPA,
        buscarAgendamentoRpaPending: true,
        buscarAgendamentoRpaError: null,
      };

    case LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_SUCCESS:
      return {
        ...state,
        registroAgendamentoRPA: action.data,
        buscarAgendamentoRpaPending: false,
        buscarAgendamentoRpaError: null,
      };

    case LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_FAILURE:
      return {
        ...state,
        buscarAgendamentoRpaPending: false,
        buscarAgendamentoRpaError: action.data.error,
      };

    case LOGIN_SAP_BUSCAR_AGENDAMENTO_RPA_DISMISS_ERROR:
      return {
        ...state,
        buscarAgendamentoRpaError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login-sap/redux/buscarAgendamentoRpa.js